import { Component, h } from 'preact'
import axios from 'axios'

import Header from '../header'
import Robots from './Robots'
import AlertComponent from '../ui-components/AlertComponent'

type Endpoints = {
  getData: string,
  saveData: string
}

interface State {
  robots: string,
  isLoading: boolean,
  messageType: 'success' | 'error' | null
}

class Seo extends Component<{}, State> {
  constructor () {
    super()
    this.state = {
      robots: '',
      isLoading: false,
      messageType: null
    }
    this.endpoints = {
      getData: '/seo/getRobots',
      saveData: '/seo/updateRobots'
    }
    this.onRobotTextChanged = this.onRobotTextChanged.bind(this)
    this.onSave = this.onSave.bind(this)
  }

  endpoints: Endpoints

  onRobotTextChanged (value: string) {
    this.setState({ robots: value })
  }

  async onSave () {
    this.setState({ isLoading: true, messageType: null })

    try {
      await axios.post(this.endpoints.saveData, {
        robots: this.state.robots
      })
      this.setState({ isLoading: false, messageType: 'success' })
    } catch (e) {
      this.setState({ isLoading: false, messageType: 'error' })
      console.log('e ', e)
    }
  }

  async componentDidMount () {
    try {
      const { data } = await axios.get(this.endpoints.getData)
      this.setState({ robots: data.robots })
    } catch (e) {
      console.log(e)
    }
  }

  render (props: {}, { robots, isLoading, messageType }: State) {
    return (
      <div>
        <Header title='Robots.txt' isLoading={isLoading} saveCallback={this.onSave} />
        { messageType ? <AlertComponent messageType={messageType} isVisibleFor={3000} /> : null }
        <Robots data={robots} onChange={this.onRobotTextChanged} />
      </div>
    )
  }
}

export default Seo
